
<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
</style>
<template>
  <v-card>
    <v-card-title>
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        สร้างบริการหรือสินค้า
      </div>
    </v-card-title>
    <v-card-text>
      <v-divider></v-divider>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete
                :items="type"
                label="ประเภทสินค้า"
                v-model="pro_type"
                :rules="ru_type"
                :disabled=" this.is_disable"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field
                label="ชื่อสินค้า"
                :disabled="this.is_disable"
                outlined
                v-model="pro_name"
                dense
                :rules="ru_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="12" class="my-n7">
              <v-textarea
                rows="3"
                outlined
                v-model="pro_detail"
                dense
                label="รายละเอียดสินค้า"
              ></v-textarea>
            </v-col>
            <v-col cols="12" lg="6">
              <v-autocomplete
                allow-overflow
                :items="unit"
                :rules="ru_unit"
                v-model="pro_unit"
                label="หน่วยสินค้า"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6">
              <v-autocomplete
                :items="category"
                :rules="ru_category"
                v-model="pro_cat"
                label="หมวดสินค้า"
                :disabled="this.is_disable"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="12" class="my-n7">
              <v-text-field
                type="number"
                label="ราคาขาย"
                :disabled="this.is_disable"
                :rules="ru_price"
                v-model="pro_price"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-divider></v-divider>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="white"
        style="width: 100px"
        light
        elevation="2"
        @click="close()"
      >
        ยกเลิก
      </v-btn>
      <v-btn
        color="success"
        style="width: 100px"
        dark
        elevation="2"
        @click="save()"
      >
        บันทึก
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ProductForm",
  props: {
    is_disable: false,
  },
  data: () => ({
    notifications: false,
    data_disabled:false,
    sound: true,
    ru_type: [(v) => !!v || "กรุณาเลือกประเภทสินค้า"],
    ru_name: [(v) => !!v || "กรุณากรอกชื่อสินค้า"],
    ru_unit: [(v) => !!v || "กรุณาเลือกหน่วยสินค้า"],
    ru_category: [(v) => !!v || "กรุณาเลือกหมวดสินค้า"],
    ru_price: [(v) => !!v || "กรุณากรอกราคา"],
    widgets: false,
    type: ['บริการ', 'สินค้า'],
    unit: ['กก.', 'เดือน', 'ปี', 'ครั้ง', 'กล่อง', 'เครื่อง', 'ชม.', 'ชิ้น', 'ชุด', 'ตัว', 'เที่ยว', 'บาท', 'ใบ', 'แผง', 'แผ่น', 'แพ๊ค', 'ม้วน', 'เมตร', 'เล่ม', 'วัน', 'สัปดาห์', 'เส้น', 'ห่อ', 'หีบ', 'โหล', 'อัน', 'ลบ.ม.'],
    category: ['ค่าบริการเหมาจ่ายรายปี', 'ค่าบริการรายเดือน', 'ค่าธรรมเนียมเก็บขน', 'ขยะเคมี', 'ขยะติดเชื้อ', 'ขยะอันตราย', 'แก๊ส']
  }),
  watch: {},
  filters: {

  },
  computed: {
    pro_type: {
      get() {
        return this.$store.getters["Product/GET_ELEMENT"].TYPE;
      },
      set(value) {
        this.$store.commit("Product/SET_ELEMENT", {
          key: "TYPE",
          value: value,
        });
      },
    },
    pro_name: {
      get() {
        return this.$store.getters["Product/GET_ELEMENT"].NAME;
      },
      set(value) {
        this.$store.commit("Product/SET_ELEMENT", {
          key: "NAME",
          value: value,
        });
      },
    },
    pro_detail: {
      get() {
        return this.$store.getters["Product/GET_ELEMENT"].DETAIL;
      },
      set(value) {
        this.$store.commit("Product/SET_ELEMENT", {
          key: "DETAIL",
          value: value,
        });
      },
    },
    pro_unit: {
      get() {
        return this.$store.getters["Product/GET_ELEMENT"].UNIT;
      },
      set(value) {
        this.$store.commit("Product/SET_ELEMENT", {
          key: "UNIT",
          value: value,
        });
      },
    },
    pro_cat: {
      get() {
        return this.$store.getters["Product/GET_ELEMENT"].CATEGORY;
      },
      set(value) {
        this.$store.commit("Product/SET_ELEMENT", {
          key: "CATEGORY",
          value: value,
        });
      },
    },
    pro_price: {
      get() {
        return this.$store.getters["Product/GET_ELEMENT"].PRICE;
      },
      set(value) {
        this.$store.commit("Product/SET_ELEMENT", {
          key: "PRICE",
          value: value,
        });
      },
    }
  },
  created() {
    console.log(this.is_disable)
    this.data_disabled = this.is_disable
  },
  methods: {

    close() {
      this.clear_form()
      this.$parent.$parent.$parent.dialog = false
    },
    clear_form() {
      this.$store.dispatch("Product/reset");
      this.$refs.form.reset();
      this.$parent.$parent.$parent.listProduct()
    },
    save() {
      let data = this.$store.getters['Product/GET_ELEMENT']
      let is_edit = this.$store.getters['Product/IS_EDIT']
      if (this.$refs.form.validate()) {
        if (is_edit) {
          this.$token_api
            .post("/update-product", data)
            .then((response) => {
              this.$swal(
                "สำเร็จ",
                "แก้ไขสำเร็จ",
                "success"
              );
              this.$store.commit('Product/SET_IS_EDIT', false)
              this.close()
            })
            .catch((error) => {
              console.log(error);
            });
        } else {

          this.$token_api
            .post("/insert-product", data)
            .then((response) => {
              this.$swal(
                "สำเร็จ",
                "บันทึกสำเร็จ",
                "success"
              );
              this.close()
            })
            .catch((error) => {
              console.log(error);
            });

        }
      } else {
        this.$swal(
          "เกิดข้อผิดพลาด",
          "กรุณากรอกข้อมูลให้ครบถ้วน",
          "warning"
        );
      }
    }
  },
  mounted() {
  },

};
</script>